import { fabric } from 'fabric';

export const getAbsoluteCenter = (object) => {
    return calculateObjectAbsolutePointByOrigin(object, 'center', 'center');
};

export const calculateObjectAbsoluteTopLeft = (object) => {
    return calculateObjectAbsolutePointByOrigin(object, 'left', 'top');
};

export const calculateObjectAbsolutePointByOrigin = (object, originX, originY) => {
    const matrix = object.calcTransformMatrix();
    // 2. choose the point you want, fro example top, left.
    const point = { x: getPointXByOrigin(object, originX), y: getPointYByOrigin(object, originY) };
    // 3. transform the point
    return fabric.util.transformPoint(point, matrix);
};

const getPointXByOrigin = (object, origin) => {
    if (origin === 'left') {
        return -object.width / 2;
    }

    if (origin === 'right') {
        return object.width / 2;
    }

    return 0;
};

const getPointYByOrigin = (object, origin) => {
    if (origin === 'top') {
        return -object.height / 2;
    }

    if (origin === 'bottom') {
        return object.height / 2;
    }

    return 0;
};

export const getBoundariesByObjects = (objects) => {
    return objects.reduce(
        (coords, object) => {
            if (coords.top === null || object.y < coords.top) {
                coords.top = object.y;
            }

            if (coords.left === null || object.x < coords.left) {
                coords.left = object.x;
            }

            if (coords.bottom === null || object.y + (object.height ?? 0) > coords.bottom) {
                coords.bottom = object.height ? object.height + object.y : object.y;
            }

            if (coords.right === null || object.x + (object.width ?? 0) > coords.right) {
                coords.right = object.width ? object.width + object.x : object.x;
            }

            return coords;
        },
        { top: null, left: null, bottom: null, right: null }
    );
};

export const getBoundariesAndCalculateZoomForSeats = ({ seats, canvasWidth, canvasHeight }) => {
    const boundaries =
        seats.length > 0
            ? getBoundariesByObjects(seats)
            : {
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
              };

    const width = boundaries.right - boundaries.left;
    const height = boundaries.bottom - boundaries.top;

    const zoom = Math.min(
        canvasWidth / (width !== 0 ? width : canvasWidth),
        canvasHeight / (height !== 0 ? height : canvasHeight)
    );

    return { boundaries, zoom };
};

export const calculateDistanceBetweenPoints = (pointA, pointB) => {
    const x = pointA.x - pointB.x;
    const y = pointA.y - pointB.y;

    return Math.sqrt(x * x + y * y);
};

export const calculateCenterOfTwoPoints = (pointA, pointB) => {
    return {
        x: (pointA.x + pointB.x) / 2,
        y: (pointA.y + pointB.y) / 2,
    };
};
export const calculateSeatDimensions = (gridConfig) => {
    const width = gridConfig.size * gridConfig.multiplier * gridConfig.seatWidth;

    const height = gridConfig.size * gridConfig.multiplier * gridConfig.seatHeight;

    return { width, height };
};
